module.exports = __webpack_public_path__ + "static/local-poster-41576365b235d6307b8b1cef607b3f15.jpg";